import { render, staticRenderFns } from "./CohortFilterItem.vue?vue&type=template&id=4e27d352&scoped=true&"
import script from "./CohortFilterItem.vue?vue&type=script&lang=js&"
export * from "./CohortFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./CohortFilterItem.vue?vue&type=style&index=0&id=4e27d352&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e27d352",
  null
  
)

export default component.exports